const doc = [({"ko":({"adminConstantHotelCheckInAnswererType":({"guest":"고객", "hotel":"시설"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;